import type React from "react";
import {useNavigate} from "react-router";
import {Button, Typography} from "@mui/material";
import {CloudSyncOutlined, HourglassEmptyOutlined} from "@mui/icons-material";
import {usePtV2Context} from "~/experiments/pages/payment-terms-v2/paymentTermsV2Context.ts";

/** Shown on every tab before the first sync or import. Non-staff users see nothing about how data gets here. */
export const PtV2EmptyState: React.FC = () => {
    const {isStaff, tabPath} = usePtV2Context();
    const navigate = useNavigate();
    if (!isStaff) {
        return <div className="ptv2-empty">
            <span className="ptv2-empty-icon"><HourglassEmptyOutlined/></span>
            <Typography component="h2" className="ptv2-empty-title">Payment terms data is not available yet</Typography>
        </div>;
    }
    return <div className="ptv2-empty">
        <span className="ptv2-empty-icon"><CloudSyncOutlined/></span>
        <Typography component="h2" className="ptv2-empty-title">No payment terms data for this databag yet</Typography>
        <Typography className="ptv2-empty-text">
            Sync the published workpapers from Hermes, or upload a zip of Hermes exports, under Data management.
        </Typography>
        <div className="ptv2-empty-actions">
            <Button variant="contained" size="small" onClick={() => navigate(tabPath('sources'))}>
                Go to Data management
            </Button>
        </div>
    </div>;
};
